import { BareButton } from '@calendly/ui/components/bare-button';
import { IconChevronRight } from '@calendly/ui/components/glyphs/IconChevronRight';
import { UiIcon } from '@calendly/ui/components/ui-icon';
const menuCss = "m1bkjbq4";
const rowCss = "rdofd79";
const rowIconCss = "rc956jv";
const rowTextCss = "rbe6ql8";
const rowLabelCss = "r1jwnmte";
const rowSubtitleCss = "r1eh95k8";

// Drill-down navigation buttons (not a tablist).
export const SectionMenu = ({
  tabs,
  onSelectTab
}) => <div className={menuCss} data-testid="editor-section-menu">
    {tabs.map(tab => <BareButton key={tab.key} type="button" className={rowCss} data-testid={`editor-section-row-${tab.key}`} onClick={() => onSelectTab(tab.key)}>
        <div className={rowIconCss}>
          <UiIcon icon={tab.icon} size="medium" title="" />
        </div>
        <span className={rowTextCss}>
          <span className={rowLabelCss}>{tab.label}</span>
          <span className={rowSubtitleCss}>{tab.subtitle}</span>
        </span>
        <UiIcon icon={IconChevronRight} size="medium" title="" />
      </BareButton>)}
  </div>;

require("./section_menu.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./section_menu.js");